import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PowerPlantCard.css';

const PowerPlantCard = ({
  plant,
  isSelected,
  onClick,
  statusColor,
  statusText
}) => {
  const navigate = useNavigate();

  const getCommunicationStatusText = (status) => {
    switch (status) {
      case 'normal': return '정상';
      case 'disconnected': return '끊김';
      default: return '알 수 없음';
    }
  };

  const getCommunicationStatusColor = (status) => {
    switch (status) {
      case 'normal': return '#10b981';
      case 'disconnected': return '#ef4444';
      default: return '#6b7280';
    }
  };

  // 더블클릭 핸들러 - 발전소 상세 페이지로 이동
  const handleDoubleClick = (e) => {
    e.stopPropagation(); // 단일 클릭 이벤트 방지
    if (plant && plant.id) {
      navigate(`/power-plant/${plant.id}`);
    }
  };

  return (
    <div
      className={`power-plant-card ${isSelected ? 'selected' : ''}`}
      onClick={onClick}
      onDoubleClick={handleDoubleClick}
      title="더블클릭하여 발전소 상세 페이지로 이동"
    >
      <div className="card-header">
        <div className="plant-name">
          {plant.name}
          <span className="double-click-icon" title="더블클릭하여 상세 페이지로 이동">⚡</span>
        </div>
        <div
          className="status-badge"
          style={{ backgroundColor: statusColor }}
        >
          {statusText}
        </div>
      </div>

      <div className="card-content">
        <div className="equipment-status">
          <div className="status-item">
            <span className="label">인버터:</span>
            <span className="value">
              {plant.inverter.working}/{plant.inverter.total}
            </span>
          </div>
          
          <div className="status-item">
            <span className="label">환경센서:</span>
            <span className="value">
              {plant.environmentSensor.working}/{plant.environmentSensor.total}
            </span>
          </div>
          
          <div className="status-item">
            <span className="label">접속반:</span>
            <span className="value">
              {plant.connectionBox.working}/{plant.connectionBox.total}
            </span>
          </div>
          
          <div className="status-item">
            <span className="label">채널:</span>
            <span className="value">
              {plant.channel.working}/{plant.channel.total}
            </span>
          </div>
        </div>

        <div className="communication-status">
          <span className="label">통신 상태:</span>
          <span 
            className="comm-status"
            style={{ color: getCommunicationStatusColor(plant.communicationStatus) }}
          >
            {getCommunicationStatusText(plant.communicationStatus)}
          </span>
        </div>

        <div className="power-info">
          <div className="power-generation">
            <span className="label">발전량:</span>
            <span className="value">
              {typeof plant.powerGeneration === 'number' ? Math.round(plant.powerGeneration).toLocaleString() : plant.powerGeneration} kW
            </span>
          </div>
          <div className="efficiency">
            <span className="label">효율:</span>
            <span className="value">
              {typeof plant.efficiency === 'number' ? plant.efficiency.toFixed(2) : plant.efficiency}%
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PowerPlantCard;
